// extracted by mini-css-extract-plugin
module.exports = {"linkPanel":"FormIntermediateStepLink_linkPanel____Acw","content":"FormIntermediateStepLink_content__GBnCu","arrowRightIcon":"FormIntermediateStepLink_arrowRightIcon__ZsY9T"};